import { Injectable } from "@angular/core";
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { isAnonymousSession } from "@/_utility/anonymous-report.util";

const IGNORED_ENDPOINTS = ["api/users/me"];

@Injectable()
export class AnonUserInterceptor implements HttpInterceptor {
    constructor(private route: ActivatedRoute) {}
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        const isIgnored = IGNORED_ENDPOINTS.some((endpoint) =>
            req.url.startsWith(endpoint),
        );
        if (isAnonymousSession(this.route.snapshot.queryParams) && !isIgnored) {
            req = req.clone({
                setParams: {
                    anon: "true",
                },
            });
        }
        return next.handle(req);
    }
}
